import Feature from 'ol/Feature';
import { LineString } from 'ol/geom';
import { Vector as VectorLayer } from 'ol/layer';
import { fromLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';

import DrawingUtils from '../utils/DrawingUtils';

import { STYLES } from '@/define/olMaps';

/**
 * Home 마커 및 경로 관리 Feature
 */
class HomeFeature {
  constructor(createOverlay, map) {
    this.createOverlay = createOverlay;
    this.map = map;
    this.homes = {};
  }

  /**
   * Home 마커 추가 또는 업데이트
   * @param {string} robotId - 로봇 ID
   * @param {Object} position - { lat, lng } 좌표
   * @param {string} color - 마커 색상
   */
  addMarker(robotId, position, color) {
    // 기존 Home Marker
    if (this.homes[robotId]) {
      this.homes[robotId].position = position;
      this.homes[robotId].marker.setPosition(fromLonLat([position.lng, position.lat]));
    }
    // 신규 Home Marker
    else {
      this.homes[robotId] = {
        position,
        marker: DrawingUtils.drawMarker(this.createOverlay, this.map, position, 'H', color),
      };
    }
  }

  /**
   * Home으로 가는 경로 추가 또는 업데이트
   * @param {string} robotId - 로봇 ID
   * @param {Object} position - 현재 로봇 위치 { lat, lng }
   */
  addPath(robotId, position) {
    // Home 미정의 시
    if (!this.homes[robotId]) return;

    // 두 점 간 직선 정의
    const from = this.homes[robotId].marker.getPosition();
    const to = fromLonLat([position.lng, position.lat]);
    const path = [from, to];

    // 기존 경로
    if (this.homes[robotId].path) {
      const feature = this.homes[robotId].path.getSource().getFeatures()[0];
      feature.getGeometry().setCoordinates(path);
    }
    // 신규 경로
    else {
      const feature = new Feature(new LineString(path));
      const source = new VectorSource({ features: [feature] });
      const layer = new VectorLayer({
        source,
        style: STYLES.LINE.RTH,
      });

      this.map.addLayer(layer);
      this.homes[robotId].path = layer;
    }
  }

  /**
   * Home 마커 및 경로 제거
   * @param {string} robotId - 로봇 ID
   */
  remove(robotId) {
    if (!this.homes[robotId]) return;

    this.map.removeOverlay(this.homes[robotId].marker);
    if (this.homes[robotId].path) {
      this.map.removeLayer(this.homes[robotId].path);
    }
    delete this.homes[robotId];
  }

  /**
   * Home 데이터 가져오기
   * @param {string} robotId - 로봇 ID
   * @returns {Object|undefined} Home 데이터
   */
  get(robotId) {
    return this.homes[robotId];
  }
}

export default HomeFeature;
